module.exports = __webpack_public_path__ + "img/usdtlogo.2aa5d163.png";